import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import Select from 'modules/core/components/Inputs/Select'
import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import type { ReportEditorStore } from 'modules/reports/lib/Store'
import dashboards from 'modules/reports/store/collections/dashboards'

interface Props {
  store: ReportEditorStore
  onSave: () => void
  onClose: () => void
  loading: boolean
}

const AssignDashboardModal = ({ store, onSave, onClose, loading }: Props) => {
  const onSaveClose = () => {
    onSave()
    onClose()
  }
  const options = React.useMemo(
    () =>
      dashboards.models.map((dashboard) => ({
        label: dashboard.attributes.title,
        value: dashboard.id,
      })),
    []
  )

  return (
    <Modal
      illustration="documents"
      title={i18n.t('custom_reports.dashboard.assign_dashboard.title')}
      description={i18n.t('custom_reports.dashboard.assign_dashboard.description')}
      onClose={onClose}
      onSubmit={onSaveClose}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={loading} submit>
            {i18n.t('common.add')}
          </Button>
        </>
      }
    >
      <Select
        none={i18n.t('custom_reports.editor.select_dashboard')}
        label={i18n.t('custom_reports.editor.dashboard')}
        field={store.reportForm.get('dashboard_id')}
        options={options}
      />
    </Modal>
  )
}

export default AssignDashboardModal
